export default __webpack_public_path__ + "static/media/Arrow_Down.bea1557e.svg";